"use strict";
exports.__esModule = true;
exports.UserTitle = exports.UserStatus = void 0;
var UserStatus;
(function (UserStatus) {
    UserStatus["INVITED"] = "INVITED";
    UserStatus["ACCEPTED"] = "ACCEPTED";
    UserStatus["FORCE_CHANGE_PASSWORD"] = "FORCE_CHANGE_PASSWORD";
})(UserStatus = exports.UserStatus || (exports.UserStatus = {}));
var UserTitle;
(function (UserTitle) {
    UserTitle["mr"] = "mr";
    UserTitle["ms"] = "ms";
    UserTitle["preferNotToSay"] = "preferNotToSay";
})(UserTitle = exports.UserTitle || (exports.UserTitle = {}));
//# sourceMappingURL=user.js.map